import { render, staticRenderFns } from "./CommonHeaderV2.vue?vue&type=template&id=2b7df5ac&scoped=true&"
import script from "./CommonHeaderV2.vue?vue&type=script&lang=js&"
export * from "./CommonHeaderV2.vue?vue&type=script&lang=js&"
import style0 from "./CommonHeaderV2.vue?vue&type=style&index=0&id=2b7df5ac&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7df5ac",
  null
  
)

export default component.exports